/**
 * trade
 * 支付API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TradeDto model module.
   * @module trade/model/TradeDto
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TradeDto</code>.
   * @alias module:trade/model/TradeDto
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>TradeDto</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:trade/model/TradeDto} obj Optional instance to populate.
   * @return {module:trade/model/TradeDto} The populated <code>TradeDto</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'Integer');
      }
      if (data.hasOwnProperty('amount')) {
        obj['amount'] = ApiClient.convertToType(data['amount'], 'Integer');
      }
      if (data.hasOwnProperty('xiaoquId')) {
        obj['xiaoquId'] = ApiClient.convertToType(data['xiaoquId'], 'Integer');
      }
      if (data.hasOwnProperty('roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'Integer');
      }
      if (data.hasOwnProperty('room')) {
        obj['room'] = ApiClient.convertToType(data['room'], 'Integer');
      }
      if (data.hasOwnProperty('outTradeNo')) {
        obj['outTradeNo'] = ApiClient.convertToType(data['outTradeNo'], 'String');
      }
      if (data.hasOwnProperty('payTime')) {
        obj['payTime'] = ApiClient.convertToType(data['payTime'], 'Date');
      }
      if (data.hasOwnProperty('finished')) {
        obj['finished'] = ApiClient.convertToType(data['finished'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 用户id
   * @member {Integer} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * 充值金额
   * @member {Integer} amount
   */
  exports.prototype['amount'] = undefined;
  /**
   * 校区id
   * @member {Integer} xiaoquId
   */
  exports.prototype['xiaoquId'] = undefined;
  /**
   * 寝室id
   * @member {Integer} roomId
   */
  exports.prototype['roomId'] = undefined;
  /**
   * 寝室
   * @member {Integer} room
   */
  exports.prototype['room'] = undefined;
  /**
   * 流水号
   * @member {String} outTradeNo
   */
  exports.prototype['outTradeNo'] = undefined;
  /**
   * 支付时间
   * @member {Date} payTime
   */
  exports.prototype['payTime'] = undefined;
  /**
   * 是否完成电控同步
   * @member {Boolean} finished
   */
  exports.prototype['finished'] = undefined;



  export default exports;
;


